import { StoreActionTypes } from './store.types';

const initialState: WebOrder.State.Store = {
  loyaltyCampaigns: undefined,
};

export const storeReducer = (
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: WebOrder.State.Store = initialState,
  action: StoreActionTypes,
): WebOrder.State.Store => {
  switch (action.type) {
    case 'SET_CAMPAIGN_PROGRESS': {
      return {
        ...state,
        loyaltyCampaigns: {
          ...state.loyaltyCampaigns,
          [action.payload.storeId]: {
            data: action.payload.data || [],
            status: action.payload.status,
          },
        },
      };
    }

    default:
      return state;
  }
};
